<div class="modal-overlay">
	<div class="modal-container">

		<!-- Header -->
		<div class="modal-header">
			<div class="modal-title">
				<span class="modal-icon">⬆</span>
				<h2>Schedule Upload Progress</h2>
				<span class="upload-id" *ngIf="data">#{{ data.uploadId }}</span>
			</div>
			<div class="status-badge" [ngClass]="data?.status | lowercase" *ngIf="data">
				<span class="status-dot"></span>
				{{ data.status }}
			</div>
		</div>

		<!-- Loading state -->
		<div class="loading-state" *ngIf="!data">
			<div class="spinner"></div>
			<p>Connecting to upload stream…</p>
		</div>

		<!-- Content -->
		<div class="modal-body" *ngIf="data">

			<!-- Message banner -->
			<div class="message-banner" *ngIf="data.message">
				<span class="message-icon">ℹ</span>
				{{ data.message }}
			</div>

			<!-- Progress bar -->
			<div class="progress-section">
				<div class="progress-label">
					<span>Overall Progress</span>
					<strong>{{ data.processingRateOverall | number:'1.0-0' }}%</strong>
				</div>
				<div class="progress-track">
					<div class="progress-fill" [style.width.%]="data.processingRateOverall"></div>
				</div>
			</div>

			<!-- Stage indicators -->
			<div class="stages">
				<div class="stage" [ngClass]="{ done: data.readingFileCompleted, pending: !data.readingFileCompleted }">
					<span class="stage-icon">{{ data.readingFileCompleted ? '✓' : '○' }}</span>
					<span>File Read</span>
				</div>
				<div class="stage-connector"></div>
				<div class="stage" [ngClass]="{ done: data.depositAmountCorrect, pending: !data.depositAmountCorrect }">
					<span class="stage-icon">{{ data.depositAmountCorrect ? '✓' : '○' }}</span>
					<span>Deposit Verified</span>
				</div>
				<div class="stage-connector"></div>
				<div class="stage" [ngClass]="{ done: data.applyingStarted, pending: !data.applyingStarted }">
					<span class="stage-icon">{{ data.applyingStarted ? '✓' : '○' }}</span>
					<span>Applying</span>
				</div>
				<div class="stage-connector"></div>
				<div class="stage" [ngClass]="{ done: data.applyingCompleted, pending: !data.applyingCompleted }">
					<span class="stage-icon">{{ data.applyingCompleted ? '✓' : '○' }}</span>
					<span>Complete</span>
				</div>
			</div>

			<!-- Stats grid -->
			<div class="stats-grid">

				<div class="stat-card highlight">
					<span class="stat-label">Processed</span>
					<span class="stat-value">{{ data.countProcessed ?? '—' }}</span>
				</div>

				<div class="stat-card success">
					<span class="stat-label">Members Added</span>
					<span class="stat-value">{{ data.countMembersAdded ?? '—' }}</span>
				</div>

				<div class="stat-card success">
					<span class="stat-label">Policies Found</span>
					<span class="stat-value">{{ data.countFoundPolicies ?? '—' }}</span>
				</div>

				<div class="stat-card success">
					<span class="stat-label">New Policy Numbers</span>
					<span class="stat-value">{{ data.countNewPolicyNumbers ?? '—' }}</span>
				</div>

				<div class="stat-card warn">
					<span class="stat-label">Invalid Product</span>
					<span class="stat-value">{{ data.countInvalidIncorrectProduct ?? '—' }}</span>
				</div>

				<div class="stat-card warn">
					<span class="stat-label">Invalid Offer</span>
					<span class="stat-value">{{ data.countInvalidIncorrectOffer ?? '—' }}</span>
				</div>

				<div class="stat-card warn">
					<span class="stat-label">Duplicates</span>
					<span class="stat-value">{{ data.countInvalidDuplicate ?? '—' }}</span>
				</div>

				<div class="stat-card warn">
					<span class="stat-label">No Member</span>
					<span class="stat-value">{{ data.countInvalidNoMember ?? '—' }}</span>
				</div>

				<div class="stat-card warn">
					<span class="stat-label">Policy to Other Member</span>
					<span class="stat-value">{{ data.countInvalidPolicyBenumbersToOtherMember ?? '—' }}</span>
				</div>

				<div class="stat-card error">
					<span class="stat-label">Failed</span>
					<span class="stat-value">{{ data.countFailed ?? '—' }}</span>
				</div>

			</div>

			<!-- Timestamps -->
			<div class="timestamps" *ngIf="data.startedAt || data.completedAt">
				<div class="timestamp" *ngIf="data.startedAt">
					<span class="ts-label">Started</span>
					<span class="ts-value">{{ data.startedAt | date:'dd MMM yyyy, HH:mm:ss' }}</span>
				</div>
				<div class="timestamp" *ngIf="data.completedAt">
					<span class="ts-label">Completed</span>
					<span class="ts-value">{{ data.completedAt | date:'dd MMM yyyy, HH:mm:ss' }}</span>
				</div>
			</div>

		</div>

	</div>
</div>
